import React from 'react'
import { withRouter } from 'react-router-dom'

import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Hidden from '@material-ui/core/Hidden'
import IconFilterList from '@material-ui/icons/FilterList'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Text from '@material-ui/core/Typography'
import Toolbar from '@material-ui/core/Toolbar'

function SectionTopNav(props){
	const [anchorEl, setAnchorEl] = React.useState(null)

	const handleChange = (value) => {
		setAnchorEl(null)
		let path = '/group/settings/' + value
		props.history.push({ pathname: path })
	 }
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}    
	const handleClose = () => {
		setAnchorEl(null)
	}
	const handleFullMenu = () => {
		setAnchorEl(null)
		props.sideNavToggle()
	}
	
	const section = props.section
	 return (
		<Toolbar variant="dense" style={{ paddingLeft:5, display: 'flex', borderBottom: '2px solid #ccc'}}>
			<Hidden smUp>
				<Button size="small" onClick={handleClick}>
               <IconFilterList style={{marginRight:5}}/> {section.replace(/-/g, ' ')}
            </Button>
			</Hidden>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				<MenuItem selected={section === 'Profile'} onClick={() => {handleChange('Profile')}}>Profile</MenuItem>
				<MenuItem selected={section === 'Plugins'} onClick={() => {handleChange('Plugins')}}>Plugins</MenuItem>
				<MenuItem selected={section === 'Payment-Options'} onClick={() => {handleChange('Payment-Options')}}>Payment Options</MenuItem>
				<MenuItem selected={section === 'Invoices'} onClick={() => {handleChange('Invoices')}}>Invoices</MenuItem>
				<MenuItem selected={section === 'Verification'} onClick={() => {handleChange('Verification')}}>Verification</MenuItem>
				<Divider />
				<MenuItem onClick={handleFullMenu}>View Full Menu</MenuItem>
			</Menu>
			<Hidden xsDown>
				<Text variant='h6' color='primary' style={{paddingLeft:5}}>{section.replace(/-/g, ' ')}</Text>
			</Hidden>
		</Toolbar>
	 )
}
export default withRouter(SectionTopNav)
